import React, { FC } from 'react';
import moment from 'moment';
import { useActivityById } from '../../../hooks/useActivities';
import ActivityDetailTable from './ActivityDetailTable';
import { ActivityDetailType, AuditDetailHeader } from '../../../@types/Audit';

const ActivityDetail: FC<{ id: string; type: ActivityDetailType }> = ({ id, type }) => {
  const { data } = useActivityById(id, type);

  if (!data) {
    return <></>;
  }

  const { audit, tableData } = data;
  const { headers, body } = tableData;

  return (
    <div className="w-full h-full overflow-auto">
      <div className="border-b-2 border-gray-20">
        <table data-testid="activity-detail-table-header" className="table-auto w-11/12 mx-auto my-8">
          {type === 'group' && (
            <>
              <thead>
                <tr className="text-left font-bold text-lg leading-5 py-4 px-3 text-gray-30">
                  <th className="px-3 py-4">Employer</th>
                  <th className="px-3 py-4">Email</th>
                  <th className="px-3 py-4">Employer activity</th>
                  <th className="px-3 py-4">Date</th>
                  {audit.jobStatus && <th className="px-3 py-4">Status</th>}
                </tr>
              </thead>
              <tbody>
                <tr className="mb-4 text-lg leading-5">
                  <td className="px-3 py-4 break-words max-w-12">{audit.main?.letter?.identifier?.name || ''}</td>
                  <td className="px-3 py-4 break-words max-w-12">{audit.main?.author?.detail?.uid || ''}</td>
                  <td className="px-3 py-4 break-words max-w-12">{audit.main?.type}</td>
                  <td className="px-3 py-4 break-words max-w-12">
                    {audit.main?.createdAt ? moment(audit.main?.createdAt).format('MM/DD/YYYY hh:mm a') : ''}
                  </td>
                  {audit.jobStatus && <td className="px-3 py-4 break-words max-w-12">{audit.jobStatus}</td>}
                </tr>
              </tbody>
            </>
          )}
          {type === 'system' && (
            <>
              <thead>
                <tr className="text-left font-bold text-lg leading-5 py-4 px-3 text-gray-30">
                  {headers.map((header: AuditDetailHeader, index: number) => (
                    <th key={`modal_header_${header.name}_${index}`} className="px-3 py-4">
                      {header.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="mb-4 text-lg leading-5">
                  {headers.map((header: AuditDetailHeader, index: number) => (
                    <td key={`modal_header_value_${header.value}_${index}`} className="px-3 py-4 break-words max-w-12">
                      {header.value}
                    </td>
                  ))}
                </tr>
              </tbody>
            </>
          )}
        </table>
      </div>
      <div className="w-full px-6">
        <ActivityDetailTable tableData={body || tableData || []} dataType={audit.main.type} />
      </div>
    </div>
  );
};

export default ActivityDetail;
